"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _rcSlider = _interopRequireDefault(require("rc-slider"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSlider = (0, _styledComponents.default)(_rcSlider.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & .rc-slider-rail,\n  & .rc-slider-track {\n    height: 10px;\n    border-radius: 5px;\n  }\n\n  & .rc-slider-rail {\n    background: ", ";\n  }\n\n  & .rc-slider-track {\n    background: white;\n  }\n\n  & .rc-slider-handle {\n    width: 28px;\n    height: 28px;\n    top: 0;\n    background: white;\n    border: 4px solid white;\n    box-shadow: 0px 0px 6px ", ";\n  }\n"])), (0, _polished.rgba)("white", 0.3), function (p) {
  return (0, _polished.rgba)(p.theme.colorSuccess, 0.5);
});

var Wrapper = function Wrapper(_ref) {
  var setFieldValue = _ref.setFieldValue,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(StyledSlider, {
    min: 5,
    max: 25,
    step: 5,
    value: value,
    onChange: function onChange(e) {
      return setFieldValue("amount", e.toFixed(2));
    }
  });
};

var _default = Wrapper;
exports.default = _default;